// NPM
import React, { Component } from 'react';

// Components
import Header from './Header';
import Footer from './Footer';

import InfoModal from './InfoModal';
import AuthModal from 'Components/Auth/AuthModal';
import ShareModal from 'Components/Pages/Results/ShareModal';

class Layout extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <main className="Layout-main-holder">{this.props.children}</main>
        <Footer className="desktop-only" />
        <AuthModal />
        <InfoModal />
        <ShareModal />
      </React.Fragment>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/Components/Layout/Layout.js